export const strToBoolTrue = value => {
  return /true/i.test(value);
};

export const strToBoolFalse = value => {
  return /false/i.test(value);
};
